<template>
    <el-dialog class="sub-waiting-dialog"
        :width="windowWidth > 600 ? '576px' : '100%'"
        :top="windowWidth > 600 ? '100px' : '0'"
        :append-to-body="true"
        :visible="true"
        :z-index="200"
    >
        <div class="subscription-waiting">
            <img src="../../../img/subscriptions/subscription-waiting.webp" alt="subscrition waiting" />
            <div class="subscription-waiting__content">
                <div class="title title--uppercase">{{ $lang('subscription.waiting_turning_on') }}</div>
                <div class="subscription-waiting__subtitle">
                    {{ $lang('subscription.waiting_congratulations') }} <span>{{ $lang(subscriptionNameLang) }}</span> {{ $lang('subscription.waiting_paid_for') }} {{ subscriptionPeriod }}.<br />
                    <span v-html="$lang('subscription.waiting_text')"></span>
                </div>

                <ul class="tariffs__a-options">
                    <li class="tariffs__a-options-item subscription-waiting__option" v-for="option in options[processing_subscription_id]">
                        <svg class="tariffs__a-options-icon" width="25" height="25">
                            <use :xlink:href="'/assets/front/img/sprite.svg#icon-' +
                                option.icon">
                            </use>
                        </svg>
                        <div>
                            <span class="tariffs__a-options-name--tree subscription-waiting__option-name"
                                v-html="option.name">
                            </span>
                            <p v-if="option.desc" v-html="option.desc" class="tariffs__a-options-desc--tree">
                            </p>
                        </div>
                    </li>
                </ul>
                <button type="button" class="btn btn--main-bg btn--middle" @click="reloadPage">{{$lang('subscription.waiting_update_status')}}</button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import Vue from 'vue';
import subscription from '../../storage/modules/subscription';

export default {
    name: 'SubscriptionWaiting',
    data() {
        return {
            processing_subscription_id: window.laravel.processing_subscription,
            options: {
                1: [
                    {
                        icon: "lock_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree_1_name")
                    },
                    {
                        icon: "free_page_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree_2_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree_2_description")
                    },
                    {
                        icon: "help_tree_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree_3_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree_3_description")
                    },
                    {
                        icon: "ai_bio",
                        name: Vue.prototype.$lang("subscription.description.tree_4_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree_4_description")
                    },
                ],
                2: [
                    {
                        icon: "lock_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree-plus_1_name")
                    },
                    {
                        icon: "free_page_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree-plus_2_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree-plus_2_description")
                    },
                    {
                        icon: "help_tree_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree-plus_3_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree-plus_3_description")
                    },
                    {
                        icon: "ai_bio",
                        name: Vue.prototype.$lang("subscription.description.tree-plus_4_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree-plus_4_description")
                    },
                ],
                3: [
                    {
                        icon: "lock_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree-plus-year_1_name"),
                    },
                    {
                        icon: "free_page_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree-plus-year_2_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree-plus-year_2_description")
                    },
                    {
                        icon: "help_tree_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree-plus-year_3_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree-plus-year_3_description")
                    },
                    {
                        icon: "ai_bio",
                        name: Vue.prototype.$lang("subscription.description.tree-plus-year_4_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree-plus-year_4_description")
                    },
                    {
                        icon: "tree_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree-plus-year_5_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree-plus-year_5_description")
                    }
                ],
                4: [
                    {
                        icon: "lock_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree-plus-promo_1_name"),
                    },
                    {
                        icon: "free_page_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree-plus-promo_2_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree-plus-promo_2_description")
                    },
                    {
                        icon: "help_tree_tariff",
                        name: Vue.prototype.$lang("subscription.description.tree-plus-promo_3_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree-plus-promo_3_description")
                    },
                    {
                        icon: "ai_bio",
                        name: Vue.prototype.$lang("subscription.description.tree-plus-promo_4_name"),
                        desc: Vue.prototype.$lang("subscription.description.tree-plus-promo_4_description")
                    }
                ]
            },
        }
    },
    computed: {
        subscriptionPeriod() {
            const subscriptionTypeId = this.processing_subscription_id;

            switch (subscriptionTypeId) {
                case 1:
                    return Vue.prototype.$lang("subscription.description.tree_period");
                case 2:
                    return Vue.prototype.$lang("subscription.description.tree-plus_period");
                case 3:
                    return Vue.prototype.$lang("subscription.description.tree-plus-year_period");
                case 4:
                    return Vue.prototype.$lang("subscription.description.tree-plus-promo_period");
            }
        },
        subscriptionNameLang(){
            if(this.processing_subscription_id == 0) {
                return "";
            }

            return window.laravel.subscriptionTypes[this.processing_subscription_id - 1].name + '_page';
        }
    },
    methods: {
        reloadPage()
        {
            sessionStorage.setItem("isWaitingClosed", "1");
            window.location.reload();
        }
    }
}
</script>
